module.exports = __webpack_public_path__ + "img/pic5.bc70b468.jpg";